import { CountryColorDataMap } from "./map-get-country-data";

/**
 * Prevent tooltips from showing up for inactive countries
 */
export const createRegionTipHandler =
  (countryData: CountryColorDataMap) =>
  (e: Event, _: unknown, code: unknown) => {
    if (typeof code !== "string" || !(code in countryData)) {
      e.preventDefault();
    }
  };
